import React, {Component} from 'react';
import '../css/Page.css';

class PageConsorzio extends Component {

    render() {
        return (
                <div className="page">
                    <article>

                        <p>L&rsquo;Areamultiservice &egrave; partner di numerosi Consorzi che possiedono diverse certificazioni ed inoltre hanno:</p>
                        <ul>
                            <li>una struttura commerciale diretta sul territorio e una struttura di assistenza gare (segnalazione e preparazione pratiche) nonch&eacute; del personale addetto alla formazione dei partner;</li>
                            <li>vantano primarie referenze di lavori pubblici, capacit&agrave; finanziaria e assicurativa, alleanze con grandi gruppi industriali, scontistiche per il gruppo di acquisto, supporto legale e di recupero credito;</li>
                            <li>interesse a stringere partnership con imprese che sfruttino al meglio le sue caratteristiche per fare fatturato, guadagnando in relazione ai progetti aggiudicati.</li>
                        </ul>

                        <p>Associarsi con un Consorzio nostro partner significa contare sempre sulla
                            possibilit&agrave; di uno sviluppo costante secondo una visione superiore alle capacit&agrave;
                            di ogni realt&agrave; considerata singolarmente.</p>

                        <p>Ecco alcuni dei numerosi <strong>VANTAGGI</strong> che i Consorzi possono offrire ai propri Associati:</p>
                        <ul>
                            <li>aumentare le potenzialit&agrave; di acquisizione lavori nel settore pubblico;</li>
                            <li>preservare i margini di guadagno nelle commesse di appalto;</li>
                            <li>utilizzare la forza della SOA del Consorzio;</li>
                            <li>utilizzare le certificazioni in possesso del Consorzio;</li>
                            <li>essere certi di ricevere supporto consulenziale risolutorio nel caso di necessit&agrave; (problematiche di cantiere, commerciali, progettuali, strategiche, legali, finanziarie)</li>
                            <li>ripartire i costi di rappresentanza utilizzando la struttura commerciale del Consorzio per il contatto con l&rsquo;Ente, anche tramite affiancamento</li>
                            <li>mantenere la propria autonomia decisionale e di gestione della propria azienda pur contando su di un consorzio alle proprie spalle come appoggio saldo. Il partner decide in piena autonomia a quali gare vuole partecipare e con che prezzi.</li>
                        </ul>


                        <p>Le aree di competenza dell&rsquo;ufficio gare sono numerose e i suoi servizi sono
                            organizzati in modo da soddisfare ogni tipo di richiesta ed esigenza dell'azienda,
                            dalla preparazione completa della documentazione per partecipare alla gara,
                            all'assistenza tecnica, ai servizi integrati.</p>

                        <p>Il servizio in particolare &egrave; stato studiato per soddisfare le esigenze delle aziende come ad esempio:</p>
                        <ul>
                            <li>poter usufruire di un vero e proprio ufficio gare in outsourcing (Esterno), con una grande ottimizzazione dei costi di personale;</li>
                            <li>partecipare nell&rsquo;immediato alle gare d&rsquo;appalto, soprattutto alle imprese che non possiedono adeguata esperienza del mondo degli appalti;</li>
                            <li>rimediare ad assenze del personale aziendale addetto alla preparazione delle gare;</li>
                        </ul>

                        <p>Richiedi un contatto personalizzato, che vi illustrer&agrave; tutti i vantaggi di consorziarsi con noi.</p>

                        <h3><strong>Lavoriamo per VOI lavorando con VOI.</strong></h3>

                    </article>
                </div>
        );
    }
}

export default PageConsorzio;


// WEBPACK FOOTER //
// ./src/page/js/PageConsorzio.js